import { ReportsRow } from '../../../modules/revenueInsightsV2/types'

export type ObjectWithReportRowValues = Record<
  string,
  keyof ReportsRow | 'collectionStatus'
>

export const awsBuyerItemsToRender: ObjectWithReportRowValues = {
  'Company name': 'buyerCompanyName',
  'Account ID': 'buyerAwsAccountId',
  'Email domain': 'buyerEmailDomain',
  City: 'buyerCity',
  'State or region': 'buyerStateOrRegion',
  Country: 'buyerCountryCode',
  'Postal code': 'buyerPostalCode',
  'Address ID': 'buyerAddressId',
  'Seller company name': 'sellerCompanyName',
}

export const awsOfferItemsToRender: ObjectWithReportRowValues = {
  'Offer name': 'privateOfferName',
  'Offer ID': 'awsOfferId',
  'Offer visibility': 'offerVisibility',
}

export const awsContractItemsToRender: ObjectWithReportRowValues = {
  'Contract ID': 'agreementId',
  'Contract start date': 'agreementStartDate',
  'Contract acceptance date': 'agreementAcceptanceDate',
  'Contract end date': 'agreementEndDate',
  'Usage period start date': 'agreementStartDate',
  'Usage period end date': 'agreementEndDate',
}

export const awsDisbursementItemsToRender: ObjectWithReportRowValues = {
  'Disbursement status': 'disbursementStatus',
  'Disbursement date': 'disbursementDate',
  'Disburse bank trace ID': 'bankTraceId',
  'Disbursement reference number': 'disbursementBillingEventId',
  'Disbursed net revenue': 'disbursedNetRevenue',
  'Undisbursed net revenue': 'undisbursedNetRevenue',
}

export const awsCollectionItemsToRender: ObjectWithReportRowValues = {
  'Collection status': 'collectionStatus',
  'Collected net revenue by AWS': 'collectedNetRevenue',
  'Uncollected net revenue': 'uncollectedNetRevenue',
  'Last collection date': 'lastCollectionDate',
}

export const awsRevenueItemsToRender: ObjectWithReportRowValues = {
  'Gross revenue': 'grossAmount',
  'Gross refund': 'grossRefund',
  'Listing fee': 'listingFee',
  'Listing fee refund': 'listingFeeRefund',
  'Listing fee percentage': 'listingFeePercentage',
  Currency: 'currency',
}

export const awsTaxItemsToRender: ObjectWithReportRowValues = {
  'Seller tax share': 'sellerTaxShare',
  'Seller tax share refund': 'sellerTaxRefund',
  'AWS tax share': 'awsTaxShare',
  'AWS tax share refund': 'awsTaxShareRefund',
  'AWS tax share listing fee': 'awsTaxShareListingFee',
  'AWS tax share refund listing fee': 'awsTaxShareRefundListingFee',
  'Wholesale seller tax share': 'wholesaleSellerTaxShare',
  'Wholesale seller tax share refund': 'wholesaleSellerTaxShareRefund',
  'Wholesale other seller tax share': 'wholesaleOtherSellerTaxShare',
  'Wholesale other seller tax share refund':
    'wholesaleOtherSellerTaxShareRefund',
  'Wholesale AWS tax share': 'wholesaleAwsTaxShare',
  'Wholesale AWS tax share refund': 'wholesaleAwsTaxShareRefund',
}

export const awsSellerItemsToRender: ObjectWithReportRowValues = {
  'Wholesale cost': 'wholeSaleCost',
  'Wholesale cost refund': 'wholeSaleCostRefund',
  'Seller net revenue': 'sellerNetRevenue',
  'Transaction reference ID': 'transactionReferenceId',
  'Reseller AWS account ID': 'resellerAWSAccountId',
  'AWS seller of record (Broker-id)': 'brokerId',
  'Resale authorization ID': 'resaleAuthorizationId',
  'Resale authorization name': 'resaleAuthorizationName',
  'Resale authorization description': 'resaleAuthorizationDescription',
  'Reseller company name': 'resellerCompanyName',
  'Listing fee invoice ID': 'listingFeeInvoiceId',
  'Wholesale invoice ID': 'wholesaleInvoiceId',
}

export const awsPayerItemsToRender: ObjectWithReportRowValues = {
  'Payer company name': 'payerCompanyName',
  'Payer AWS account ID': 'payerAwsAccountId',
  'Payer email domain': 'payerEmailDomain',
  'Payer city': 'payerCity',
  'Payer state or region': 'payerStateOrRegion',
  'Payer country': 'payerCountryCode',
  'Payer postal code': 'payerPostalCode',
  'Payer address ID': 'payerAddressId',
  'Payer encrypted account ID': 'payerEncryptedAccountId',
}

export const azureBuyerItemsToRender: ObjectWithReportRowValues = {
  'Billing account ID': 'billingAccountId',
  'Account ID': 'cloudBuyerAccountId',
  'Email domain': 'buyerEmailDomain',
  City: 'buyerCity',
  'State or region': 'buyerStateOrRegion',
  Country: 'buyerCountryCode',
  'Postal code': 'buyerPostalCode',
}

export const azureOfferItemsToRender: ObjectWithReportRowValues = {
  'Offer name': 'privateOfferName',
  'Offer ID': 'cloudOfferId',
  'Plan name': 'planName',
  'Offer type': 'offerVisibility',
}

export const azureContractItemsToRender: ObjectWithReportRowValues = {
  'Contract ID': 'agreementId',
  'Contract start date': 'agreementStartDate',
  'Contract end date': 'agreementEndDate',
}

export const azureDisbursementItemsToRender: ObjectWithReportRowValues = {
  'Disbursement status': 'disbursementStatus',
  'Disbursement date': 'disbursementDate',
}

export const azureRevenueItemsToRender: ObjectWithReportRowValues = {
  'Gross revenue': 'grossAmount',
  'Listing fee': 'listingFee',
  'Listing fee percentage': 'listingFeePercentage',
  Currency: 'currency',
}

export const azureResellerItemsToRender: ObjectWithReportRowValues = {
  'Reseller name': 'resellerCompanyName',
  'Reseller account ID': 'resellerAccountId',
}

export const gcpBuyerItemsToRender: ObjectWithReportRowValues = {
  'Account ID': 'accountId',
  'Email domain': 'emailDomain',
  'State or region': 'state',
  Country: 'country',
  'Postal code': 'postalCode',
}

export const gcpOfferItemsToRender: ObjectWithReportRowValues = {
  'Offer name': 'offerName',
  'Offer ID': 'offerId',
  'Offer type': 'offerType',
}

export const gcpContractItemsToRender: ObjectWithReportRowValues = {
  'Contract ID': 'contractId',
  'Contract start date': 'contractStartDate',
  'Contract end date': 'contractEndDate',
  'Usage period start date': 'usagePeriodStartDate',
}

export const gcpDisbursementItemsToRender: ObjectWithReportRowValues = {
  'Disbursement date': 'disbursementDate',
  'Payout entity': 'payoutEntity',
}

export const gcpRevenueItemsToRender: ObjectWithReportRowValues = {
  'Gross revenue': 'grossRevenue',
  'Gross refund': 'grossRefund',
  'Listing fee': 'listingFee',
  'Listing fee percentage': 'listingFeePercentage',
  Currency: 'currency',
}
